import ShopView from './Shop/View';
import ShopHome from './ShopHome';

const Shop = {
  Home: ShopHome,
  View: ShopView,
};

export default Shop;
